/**
 * ============================================================================
 * PAGINA: Index.tsx (Root Route)
 * ============================================================================
 * 
 * Questa rotta non è più una "vetrina" pubblica.
 * Il portale è strutturalmente privato. 
 * Gli utenti non loggati vengono reindirizzati al login tramite AuthGuard.
 * Gli utenti loggati che atterrano qui vengono reindirizzati alla loro Dashboard.
 * ============================================================================
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

export default function Index() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Se l'autenticazione è caricata e l'utente esiste, mandalo al cruscotto
    if (!loading && user) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, loading, navigate]);

  // Se l'utente non è loggato, l'AuthGuard interverrà e lo manderà su /auth.
  // Nel frattempo (frazione di secondo) mostriamo un indicatore di caricamento.
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Reindirizzamento in corso...</p>
      </div>
    </div>
  );
}